import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-training-certificate-grid',
  templateUrl: './training-certificate-grid.component.html',
  styleUrls: ['./training-certificate-grid.component.css']
})
export class TrainingCertificateGridComponent implements OnInit {
 title="Form-IV: Form for Training certificate";
  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/pages/functions/training-certificate/training-certificate-grid/training-certificate-grid.component.ts